import {
  SIDEKICK_PANEL_WIDTH,
  selectIsPanelOpen,
} from '@brightdrop/ai-sidekick';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useSelector } from 'react-redux';

import { SIDEKICK_PUSH_MIN_VIEWPORT_PX } from '~/common/constants/sidekick.constants';

/**
 * Width (px) the app shell's main column must give up to the Sidekick
 * drawer.
 *
 * Below `SIDEKICK_PUSH_MIN_VIEWPORT_PX` the drawer overlays behind its
 * own scrim and owns that range on its own, so the column keeps its
 * full width and this returns 0.
 *
 * The shared `SidePanelLayout` cannot do this job here: the drawer
 * mounts inside `AppContent`, several levels below the `<main>` that
 * has to shrink.
 *
 * @returns `SIDEKICK_PANEL_WIDTH` while the drawer is pushing, else 0.
 */
export const useSidekickContentInset = (): number => {
  const isPanelOpen = useSelector(selectIsPanelOpen);
  const isPushViewport = useMediaQuery(
    `(min-width:${SIDEKICK_PUSH_MIN_VIEWPORT_PX}px)`
  );

  return isPanelOpen && isPushViewport ? SIDEKICK_PANEL_WIDTH : 0;
};
